import { COLORS } from '@btime/constants'
import { prop } from 'ramda'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useModalData } from '../../../components/modals/ModalsContext'
import { useServiceOrders } from './_load/ServiceOrdersLoader'
import Button from '../../../components/actions/Button'
import FlexGrid from '../../../components/structure/FlexGrid'
import Separator from '../../../components/helpers/Separator'
import useRemoveServiceOrders from './_requests/removeBulk'

const RemoveButton = () => {
  const { t } = useTranslation('serviceOrders')
  const data = useModalData()
  const serviceOrders = useServiceOrders()
  const serviceOrdersIds = serviceOrders.map(prop('id'))

  const [deleteItems, { loading }] = useRemoveServiceOrders(data.onSuccess)

  return (
    <Button onClick={() => deleteItems(serviceOrdersIds)} loading={loading} color={COLORS.red}>
      {t('remove.button')}
    </Button>
  )
}

const ModelFooter = () => {
  return (
    <>
      <Separator weight={6} />
      <FlexGrid justify="space-between" gutter={0.3}>
        <div />
        <RemoveButton />
      </FlexGrid>
    </>
  )
}

export default ModelFooter
